import { VehicleCategory, VehicleInfo } from "fleet/business/Fleet";
import * as IFleetRepository from "../business/IFleetRepository";
import { injectable, provided } from "inversify-sugar";

@injectable()
export default class FleetUseCase {
  @provided(IFleetRepository.IFleetRepositoryToken)
  private fleetRepository!: IFleetRepository.IFleetRepository;

  public createVehicleCategory(values: any) {
    return this.fleetRepository.createVehicleCategory(values);
  }

  public getAllVechiles(page: number, input: string, filter: string, report: string, limit: number) {
    return this.fleetRepository.getAllVechiles(page, input, filter, report, limit);
  }

  public getAllVehiclesOfDriver(driverId: number) {
    return this.fleetRepository.getAllVehiclesOfDriver(driverId);
  }

  public getAVehicle(id: number) {
    return this.fleetRepository.getAVehicle(id);
  }

  public deleteVehicle(id: number) {
    return this.fleetRepository.deleteVehicle(id);
  }

  public updateVehicle(id: number, values: VehicleCategory) {
    return this.fleetRepository.updateVehicle(id, values);
  }

  public changeVehicleRequestStatus(id: number, values: any) {
    return this.fleetRepository.changeVehicleRequestStatus(id, values);
  }

  public checkVehicleExistance(values: any) {
    return this.fleetRepository.checkVehicleExistance(values);
  }
  public getAllChangeRequests(page: number, input: string, filter: string) {
    return this.fleetRepository.getAllChangeRequests(page, input, filter);
  }

  public changeVehicleOwn(id: number, values: any) {
    return this.fleetRepository.changeVehicleOwn(id, values);
  }

  public changeVehicleOthers(id: number, values: any) {
    return this.fleetRepository.changeVehicleOthers(id, values);
  }

  public getAllVehicleCategory(page: number, input: string, filter: string) {
    return this.fleetRepository.getAllVehicleCategory(page, input, filter);
  }

  public deleteVehicleCategory(id: number) {
    return this.fleetRepository.deleteVehicleCategory(id);
  }

  public getVehicleCategory(id: number) {
    return this.fleetRepository.getVehicleCategory(id);
  }

  public updateVehicleCategory(id: number, values: VehicleCategory) {
    return this.fleetRepository.updateVehicleCategory(id, values);
  }

  public getUnits() {
    return this.fleetRepository.getUnits();
  }

  public createUnit(values: any) {
    return this.fleetRepository.createUnit(values);
  }

  public createVehicleTypes(values: any) {
    return this.fleetRepository.createVehicleTypes(values);
  }

  public updateVehicleTypes(id: number, values: any) {
    return this.fleetRepository.updateVehicleTypes(id, values);
  }

  public getAllVehicleTypes(page: number, input: string, filter: string) {
    return this.fleetRepository.getAllVehicleTypes(page, input, filter);
  }

  public deleteVehicleType(id: number) {
    return this.fleetRepository.deleteVehicleType(id);
  }

  public getVehicleType(id: number) {
    return this.fleetRepository.getVehicleType(id);
  }

  public getAllVehicleOwnerList = () => {
    return this.fleetRepository.getAllVehicleOwnerList();
  };

  public getTripCoordinatesById = (id: number) => {
    return this.fleetRepository.getTripCoordinatesById(id);
  };

  public getAllVehiclePlateColors = () => {
    return this.fleetRepository.getAllVehiclePlateColors();
  };

  public getVehiclePolicyTypes = () => {
    return this.fleetRepository.getVehiclePolicyTypes();
  };

  public createVehicle = (values: any) => {
    return this.fleetRepository.createVehicle(values);
  };

  public transferOwnership = (values: any) => {
    return this.fleetRepository.transferOwnership(values);
  };

  public createTrip = (values: any) => {
    return this.fleetRepository.createTrip(values);
  };
  public getAllTrip(page: number, input: string, filter: string, ongoing: string, createdOnly?: boolean) {
    return this.fleetRepository.getAllTrip(page, input, filter, ongoing, createdOnly);
  }

  public getAllCompletedTrips(page: number) {
    return this.fleetRepository.getAllCompletedTrips(page);
  }

  public deleteTrip(id: number) {
    return this.fleetRepository.deleteTrip(id);
  }

  public getATrip(id: number, showMap: boolean) {
    return this.fleetRepository.getATrip(id, showMap);
  }

  public updateTrip(id: number, values: any) {
    return this.fleetRepository.updateTrip(id, values);
  }

  public updateTripStatus(id: number, values: any) {
    return this.fleetRepository.updateTripStatus(id, values);
  }
  public getAvailableVehicleForBidding(id: number) {
    return this.fleetRepository.getAvailableVehicleForBidding(id);
  }

  public getNewBids(page: number, input?: string, filter?: string) {
    return this.fleetRepository.getNewBids(page, input, filter);
  }

  //new bid request
  public newBidRequest(values: any) {
    return this.fleetRepository.newBidRequest(values);
  }

  public getRejectedBids(page: number, input: string, filter?: string) {
    return this.fleetRepository.getRejectedBids(page, input, filter);
  }
  public getAcceptedBids(page: number, input?: string, filter?: string) {
    return this.fleetRepository.getAcceptedBids(page, input, filter);
  }
  public acknowledgeDigitalContract(id: number) {
    return this.fleetRepository.acknowledgeDigitalContract(id);
  }

  public acknowledgeContract(values: any) {
    return this.fleetRepository.acknowledgeContract(values);
  }

  //cancel bid request
  public cancelBidRequest(values: VehicleInfo) {
    return this.fleetRepository.cancelBidRequest(values);
  }

  //payment
  public userPayment(values: any) {
    return this.fleetRepository.userPayment(values);
  }

  public transactionPayment(values: any) {
    return this.fleetRepository.transactionPayment(values);
  }

  //cancel order
  public cancelOrder(values: VehicleInfo) {
    return this.fleetRepository.cancelOrder(values);
  }

  public getAllVehicles() {
    return this.fleetRepository.getAllVehicles();
  }

  public getVehicleCheckList(page: number, input: string, filter: string) {
    return this.fleetRepository.getVehicleCheckList(page, input, filter);
  }

  public getVehicleLogHistory(page: number, input: string, filter: string) {
    return this.fleetRepository.getVehicleLogHistory(page, input, filter);
  }
  public getDeclinedVehicleReport(page: number, input: string, filter: string) {
    return this.fleetRepository.getDeclinedVehicleReport(page, input, filter);
  }
  public getRejectedVehicleReport(page: number, input: string) {
    return this.fleetRepository.getRejectedVehicleReport(page, input);
  }
  public getEditRequestVehicleReport(page: number, input: string, filter: string) {
    return this.fleetRepository.getEditRequestVehicleReport(page, input, filter);
  }
  public getAwaitingApprovalVehicleReport(page: number, input: string, filter: string) {
    return this.fleetRepository.getAwaitingApprovalVehicleReport(page, input, filter);
  }

  public getTQMSPendingVehicles(page: number, input: string, filter: string) {
    return this.fleetRepository.getTQMSPendingVehicles(page, input, filter);
  }

  public getLoadBoardPendingVehicles(page: number, input: string, filter: string) {
    return this.fleetRepository.getLoadBoardPendingVehicles(page, input, filter);
  }

  public getAwaitingApprovalDriverReport(type: string, page: number, input: string) {
    return this.fleetRepository.getAwaitingApprovalDriverReport(type, page, input);
  }

  public getStatusVehicleReport(values: any) {
    return this.fleetRepository.getStatusVehicleReport(values);
  }

  public getProformaInvoice(id: number) {
    return this.fleetRepository.getProformaInvoice(id);
  }

  public getStatusDriverReport(values: any) {
    return this.fleetRepository.getStatusDriverReport(values);
  }
  //insurance company
  public getInsuranceCompany() {
    return this.fleetRepository.getInsuranceCompany();
  }

  public checkUniqueVehicleNumber(vehicleNumber: string) {
    return this.fleetRepository.checkUniqueVehicleNumber(vehicleNumber);
  }

  public validateGpsDeviceId(gpsDeviceId: string, vehicleId?: number) {
    return this.fleetRepository.validateGpsDeviceId(gpsDeviceId, vehicleId);
  }

  public getUnAssignedDriver() {
    return this.fleetRepository.getUnassignedDriver();
  }

  public getAllDriversOfVehicle(vehicleId: number) {
    return this.fleetRepository.getAllDriversOfVehicle(vehicleId);
  }

  public assignDriver(values: any) {
    return this.fleetRepository.assignDriver(values);
  }

  public updateVehicleStatus(id: number, data: any) {
    return this.fleetRepository.updateVehicleStatus(id, data);
  }

  public getOrderBidDetails(id: number) {
    return this.fleetRepository.getOrderBidDetails(id);
  }

  //Getting the onboarding data
  public getOnboardingData(status: string, type: string, page: number, input: string) {
    return this.fleetRepository.getOnboardingData(status, type, page, input);
  }

  public getVehicleOnBoardingLists(page: number, input: string, filter: string, status?: string) {
    return this.fleetRepository.getVehicleOnBoardingLists(page, input, filter, status);
  }

  public setVehicleEditOnBoarding(id: number, value: any) {
    return this.fleetRepository.setVehicleEditOnBoarding(id, value);
  }

  //for getting the details of vehicle by id
  public getVehicleDetailsById(value: { vehicleId: number }) {
    return this.fleetRepository.getVehicleDetailsById(value);
  }

  //sthaniya
  public getSthaniya() {
    return this.fleetRepository.getSthaniya();
  }

  public getTQMSVehicleDetails(id: number) {
    return this.fleetRepository.getTQMSVehicleDetails(id);
  }

  public getPendingVehicleDetails(id: number) {
    return this.fleetRepository.getPendingVehicleDetails(id);
  }
  public getPendingApprovalVehicles(page: number, input: string, filter: string, status: string) {
    return this.fleetRepository.getPendingApprovalVehicles(page, input, filter, status);
  }

  public acceptrejectvehicle(values: any) {
    return this.fleetRepository.acceptrejectvehicle(values);
  }

  public getTripActualPath(id: number) {
    return this.fleetRepository.getTripActualPath(id);
  }

  public getAVehicleChangeRequestById(id: number) {
    return this.fleetRepository.getAVehicleChangeRequestById(id);
  }

  public getAllVirtualCheckpoints(page: number, input: string, filter: string) {
    return this.fleetRepository.getVirtualCheckpoints(page, input, filter);
  }

  public createVirtualCheckpoint(values: any) {
    return this.fleetRepository.createVirtualCheckpoint(values);
  }

  public updateVirtualCheckpoint(id: number, values: any) {
    return this.fleetRepository.updateVirtualCheckpoint(id, values);
  }

  public deleteVirtualCheckpoint(id: number) {
    return this.fleetRepository.deleteVirtualCheckpoint(id);
  }
  public getPaymentDetails(txnId: string) {
    return this.fleetRepository.getPaymentDetails(txnId);
  }

  public getNepalPayDetails(validationTraceId: string) {
    return this.fleetRepository.getNepalPayDetails(validationTraceId);
  }

  public getVehiclePlanTrend(page: number, input: string, filter: string, vehicleId: number) {
    return this.fleetRepository.getVehiclePlanTrend(page, input, filter, vehicleId);
  }

  public getVehicleScheduledPlan(page: number, input: string, filter: string, vehicleId: number) {
    return this.fleetRepository.getVehicleScheduledPlan(page, input, filter, vehicleId);
  }

  // Add getCancelledPlan use case
  public getCancelledPlan(vehicleId: number) {
    return this.fleetRepository.getCancelledPlan(vehicleId);
  }

  public updateContractVehicle(id: any, values: any) {
    return this.fleetRepository.updateContractVehicle(id, values);
  }

  public getVehicleContractHistory = (vehicleId: number) => {
    return this.fleetRepository.getVehicleContractHistory(vehicleId);
  };

  public getCancelledBids(page: number, input: string, filter?: string) {
    return this.fleetRepository.getCancelledBids(page, input, filter);
  }

  // Add cancelSubscription use case
  public cancelSubscription(vehicleId: number, data: { documentId?: number; additionalDetails?: string }) {
    // vehicleId is used as subscriptionId in API
    return this.fleetRepository.cancelSubscription(vehicleId, data);
  }

  public getApplicableCancellationPolicy(vehicleId: number) {
    return this.fleetRepository.getApplicableCancellationPolicy(vehicleId);
  }

  public getSubscriptionExpiryReminders() {
    return this.fleetRepository.getSubscriptionExpiryReminders();
  }

  public updateSubscriptionExpiryReminder(reminderId: number, data: { remindBeforeDays: number }) {
    return this.fleetRepository.updateSubscriptionExpiryReminder(reminderId, data);
  }

  public updatePlan(values: any) {
    return this.fleetRepository.updatePlan(values);
  }

  public updatePaymentStatus(values: any) {
    return this.fleetRepository.updatePaymentStatus(values);
  }

  public verifyPromoCode(values: any) {
    return this.fleetRepository.verifyPromoCode(values);
  }

  public getApplicablePromoCode(page: number, limit?: number, search?: string, filter?: string) {
    return this.fleetRepository.getApplicablePromoCode(page, limit, search, filter);
  }

  public getAppliedPromoCode(page: number, limit?: number, search?: string, filter?: string) {
    return this.fleetRepository.getAppliedPromoCode(page, limit, search, filter);
  }

  public getLiveShipmentTrack() {
    return this.fleetRepository.getLiveShipmentTrack();
  }

  public getPaymentLogs(values: any) {
    return this.fleetRepository.getPaymentLogs(values);
  }

  public getCommissionReport(values: any) {
    return this.fleetRepository.getCommissionReport(values);
  }

  public getUnassignedDriverV2(vehicleId: number) {
    return this.fleetRepository.getUnassignedDriverV2(vehicleId);
  }

  public getUnassignedVehicleV2(driverId: number) {
    return this.fleetRepository.getUnassignedVehicleV2(driverId);
  }

  public getSearchVehicle(query: string) {
    return this.fleetRepository.getSearchVehicle(query);
  }

  public vehicleAction(vehicleId: number, values: any) {
    return this.fleetRepository.vehicleAction(vehicleId, values);
  }

  public shiftVehicleOwnerThunk(vehicleId: number, values: any) {
    return this.fleetRepository.shiftVehicleOwnerThunk(vehicleId, values);
  }

  public getAllVehicleStatus() {
    return this.fleetRepository.getAllVehicleStatus();
  }

  public updateEligibleVehicleStatus(vehicleStatusId: number) {
    return this.fleetRepository.updateEligibleVehicleStatus(vehicleStatusId);
  }

  public updatePlanFeatures(planId: number, featureIds: number[]) {
    return this.fleetRepository.updatePlanFeatures(planId, featureIds);
  }
}
